import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/context/AuthContext";
import { useProfileData } from "src/hooks/useProfileData";
import { useSubscriptionWorkflowStore } from "src/store/subscriptionWorkflowStore";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "src/components/ui/Card";
import { Button } from "src/components/ui/Button";
import { 
  Breadcrumb, 
  BreadcrumbList, 
  BreadcrumbItem, 
  BreadcrumbLink, 
  BreadcrumbSeparator, 
  BreadcrumbPage 
} from "src/components/ui/Breadcrumb";
import { 
  BookOpen, 
  ArrowRight,
  ArrowLeft,
  Home
} from "lucide-react";
import { Link } from "react-router-dom";
import { ROUTES } from "src/routes/RouteConfig";

const NewSubscriptionConfigure: React.FC = () => {
  const navigate = useNavigate();
  const { displayName } = useProfileData();
  const { currentWorkflow } = useSubscriptionWorkflowStore();

  const handleContinue = () => {
    navigate(ROUTES.STUDENT_NEW_SUBSCRIPTION_PRICING.path);
  };

  const handleBack = () => {
    navigate(ROUTES.STUDENT_NEW_SUBSCRIPTION_SELECT.path);
  };

  return (
    <>
      {/* Breadcrumb Navigation */}
      <div className="mb-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={ROUTES.STUDENT_DASHBOARD.path} className="flex items-center">
                  <Home className="h-4 w-4 mr-1" />
                  Dashboard
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={ROUTES.STUDENT_SUBSCRIPTIONS.path}>
                  Subscriptions
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={ROUTES.STUDENT_NEW_SUBSCRIPTION.path}>
                  New Subscription
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Configure Curriculum</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <div className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <BookOpen className="h-5 w-5 mr-2" />
              Configure Curriculum
            </CardTitle>
            <CardDescription>
              Choose the published curriculum scope and objective plan for your {currentWorkflow?.product_type} package
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-12">
              <BookOpen className="h-16 w-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Curriculum Configuration
              </h3>
              <p className="text-gray-600 mb-6">
                This step will let you choose a published scope and, where appropriate, canonical domains, units, lessons, objectives, or an approved exam blueprint.
              </p>
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-blue-800 text-sm">
                  <strong>Coming Soon:</strong> The student configuration surface will use the same protected canonical-plan resolver as admin enrollment.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Navigation Buttons */}
        <div className="flex justify-between">
          <Button
            variant="outline"
            onClick={handleBack}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <Button onClick={handleContinue}>
            Continue
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </>
  );
};

export default NewSubscriptionConfigure;
